/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RasterEditUrls
 */
export interface RasterEditUrls {
  /**
   *
   */
  rasterType: string;
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the RasterEditUrls interface.
 */
export function instanceOfRasterEditUrls(value: object): value is RasterEditUrls {
  if (
    (!("rasterType" in (value as Record<string, any>)) &&
      !("raster_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["rasterType"] === undefined &&
      (value as Record<string, any>)["raster_type"] === undefined)
  )
    return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function RasterEditUrlsFromJSON(json: any): RasterEditUrls {
  return RasterEditUrlsFromJSONTyped(json, false);
}

export function RasterEditUrlsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterEditUrls {
  if (json == null) {
    return json;
  }
  return {
    rasterType: json["raster_type"],
    url: json["url"],
  };
}

export function RasterEditUrlsToJSON(json: any): RasterEditUrls {
  return RasterEditUrlsToJSONTyped(json, false);
}

export function RasterEditUrlsToJSONTyped(
  value?: RasterEditUrls | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    raster_type: value["rasterType"],
    url: value["url"],
  };
}
